/**
 * Extract a human-readable error message from a Convex error.
 * ConvexError stores the message in e.data; regular Error uses e.message.
 * Also checks nested .error, .cause, and .data properties.
 */
export function getErrorMessage(e: unknown): string {
	if (e != null && typeof e === "object") {
		const err = e as Record<string, unknown>
		if (typeof err.data === "string") {
			return err.data
		}
		// ConvexError with structured data — extract .data.message
		if (err.data != null && typeof err.data === "object") {
			const dataObj = err.data as Record<string, unknown>
			if (typeof dataObj.message === "string") {
				return dataObj.message
			}
		}
		if (typeof err.message === "string") {
			return err.message
		}
		if (err.error != null && typeof err.error === "object") {
			const nested = err.error as Record<string, unknown>
			if (typeof nested.message === "string") {
				return nested.message
			}
		}
		if (err.cause != null && typeof err.cause === "object") {
			const nested = err.cause as Record<string, unknown>
			if (typeof nested.message === "string") {
				return nested.message
			}
		}
	}
	if (typeof e === "string") {
		return e
	}
	return "Something went wrong"
}

/**
 * Check whether an error is a FREE_QUOTA_EXHAUSTED ConvexError.
 */
export function isQuotaExhausted(e: unknown): boolean {
	return getConvexErrorCode(e) === "FREE_QUOTA_EXHAUSTED"
}

/**
 * Check whether an error is a FREE_REPLY_LIMIT ConvexError.
 */
export function isReplyLimitError(e: unknown): boolean {
	return getConvexErrorCode(e) === "FREE_REPLY_LIMIT"
}

function getConvexErrorCode(e: unknown): string | undefined {
	if (e != null && typeof e === "object") {
		const err = e as Record<string, unknown>
		if (err.data != null && typeof err.data === "object") {
			const code = (err.data as Record<string, unknown>).code
			if (typeof code === "string") {
				return code
			}
		}
	}
	return undefined
}
